import { Actions } from './actions';
import {
  POST_GET_ALL_SERIES_REQUEST,
  POST_GET_ALL_SERIES_SUCCESS,
  POST_GET_ALL_SERIES_ERROR,
  POST_UNRESERVE_MARKING_CODE_REQUEST,
  POST_UNRESERVE_MARKING_CODE_SUCCESS,
  POST_UNRESERVE_MARKING_CODE_ERROR,
  POST_GET_SERIES_DETAILED_REQUEST,
  POST_GET_SERIES_DETAILED_SUCCESS,
  POST_GET_SERIES_DETAILED_ERROR,
  CLOSE_ERROR_POPUP_SERIES,
} from './constants';

const initialState = {
  modalLoading: false as boolean,
  detailedModalLoading: false as boolean,
  loading: false as boolean,
  error: null as Error | null,
  seriesList: [] as any,
  seriesListErrorResponse: {} as any,

  seriesDetailed: {} satisfies any | null,
  seriesDetailedErrorResponse: {} satisfies any | null,

  unreserveMarkingCode: null as any,
  unreserveMarkingCodeErrorResponse: {} as any,
};

export type SeriesState = typeof initialState;

export const SeriesReducer = (state: SeriesState = initialState, action: Actions) => {
  switch (action.type) {
    case POST_GET_ALL_SERIES_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case POST_GET_ALL_SERIES_SUCCESS: {
      return {
        ...state,
        loading: false,
        seriesList: action.payload,
      };
    }
    case POST_GET_ALL_SERIES_ERROR: {
      return {
        ...state,
        loading: false,
        seriesListErrorResponse: action.payload,
      };
    }

    case POST_UNRESERVE_MARKING_CODE_REQUEST: {
      return {
        ...state,
        modalLoading: true,
      };
    }
    case POST_UNRESERVE_MARKING_CODE_SUCCESS: {
      return {
        ...state,
        modalLoading: false,
        unreserveMarkingCode: action.payload,
      };
    }
    case POST_UNRESERVE_MARKING_CODE_ERROR: {
      return {
        ...state,
        modalLoading: false,
        unreserveMarkingCodeErrorResponse: {},
      };
    }

    case POST_GET_SERIES_DETAILED_REQUEST: {
      return {
        ...state,
        detailedModalLoading: true,
        seriesDetailed: null,
      };
    }
    case POST_GET_SERIES_DETAILED_SUCCESS: {
      return {
        ...state,
        detailedModalLoading: false,
        seriesDetailed: action.payload,
      };
    }
    case POST_GET_SERIES_DETAILED_ERROR: {
      return {
        ...state,
        detailedModalLoading: false,
        seriesDetailed: null,
        seriesDetailedErrorResponse: action.payload,
      };
    }

    case CLOSE_ERROR_POPUP_SERIES: {
      return {
        ...state,
        seriesListErrorResponse: {},
        unreserveMarkingCodeErrorResponse: {},
        seriesDetailedErrorResponse: {},
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};
